/**
 * Given two nodes (which should be siblings), get the nodes between them.
 * @param $nodeA The first node.
 * @param $nodeB The second node.
 * @return {*[]} The matched nodes.
 */
function getNodesBetween($nodeA, $nodeB) {
    const $elements = [];

    let $current = $nodeA.nextSibling;
    while ($current && $current !== $nodeB) {
        $elements.push($current);
        $current = $current.nextSibling;
    }

    return $elements;
}

/**
 * Given an instance ID and some content, replace the elements between the two corresponding markers with the content.
 *
 * @param instanceId The instance ID to use.
 * @param content The content to be placed.
 */
function replacePageContentForInstance(instanceId, content) {
    const $markers = document.querySelectorAll(`script[type="text/agend-query-filter-marker"][data-instance-id="${instanceId}"]`);

    if ($markers.length !== 2) {
        console.warn('Expected 2 markers for instance: ', instanceId);
        return;
    }

    // Get all elements between the two markers.
    const $elements = getNodesBetween($markers[0], $markers[1]);

    // Replace the elements with the new content.
    $elements.forEach($element => $element.remove());

    $markers[0].insertAdjacentHTML('afterend', content);

    // Get all new elements between the two markers.
    const $newElements = getNodesBetween($markers[0], $markers[1]);

    initElementorWidgets($newElements);

    // Make sure any replaced filter forms are re-initialized.
    initializeFilterForms();
}

/**
 * Submit the form of a container, optionally with extra data to be added to the post.
 *
 * @param {HTMLElement} $container The container to find the form to submit.
 * @param {object} extraData The extra data to include in the form's payload.
 */
function submitContainerForm($container, extraData = {}) {

    const $form = $container.querySelector('form');

    if (!$form) {
        console.warn('Container had no form, how did the event get fired?');
        return;
    }

    // Already searching? bail...
    if ($container.classList.contains('filtering')) {
        return;
    }

    // Get the form's data.
    const formData = new FormData($form);
    const data = Object.fromEntries(formData);
    data.action = 'agend_query_filter';

    Object.entries(extraData).forEach(entry => {
        data[entry[0]] = entry[1];
    });

    const instanceId = data?.agend_query_filter_instance_id;

    // This shouldn't really happen...
    if (!instanceId) {
        console.warn('There was no instance ID, how?');
        return;
    }

    $container.classList.add('filtering');

    jQuery.ajax({
        method: 'POST',
        url: agendQueryFilter.url,
        data
    })
        .done(result => {
            replacePageContentForInstance(instanceId, result);
        })
        .fail(error => {
            console.log('Error performing filter: ', error);
            alert('Sorry, there was an error performing the filter. Please try again later.');
        })
        .always(() => {
            $container.classList.remove('filtering');

            // Not sure why I'm checking, support is really good now...
            if (typeof $container.scrollIntoView === 'function') {
                $container.scrollIntoView({behavior: "smooth", block: "start"});
            }
        });
}

function setupFormContainer($container) {
    // Watch for submit events - catch those and push through AJAX.
    const triggerSubmission = event => {
        event.stopImmediatePropagation();
        event.preventDefault();

        const extraData = {};

        // Include the pager button value, if the source of the event was from a button.
        if (
            event?.submitter?.tagName === 'BUTTON'
            && event?.submitter?.type === 'submit'
            && event?.submitter?.name
            && event?.submitter?.value
        ) {
            extraData[event?.submitter?.name] = event?.submitter?.value;
        }

        submitContainerForm($container, extraData);
    };

    $container.addEventListener('submit', triggerSubmission);
    $container.addEventListener('change', triggerSubmission);

    $container.dataset.agendQueryFilterInitialized = 'initialized';
}

/**
 * Given a collection of elements, attempt to init any Elementor elements contained.
 * @param $elements The elements to potentially init.
 */
function initElementorWidgets($elements) {
    if (typeof elementorFrontend?.elementsHandler?.runReadyTrigger !== 'function') {
        return;
    }

    $elements.forEach($element => {
        // If it's just a text node, skip...
        if ($element.nodeType === Node.TEXT_NODE) {
            return;
        }
        // Init the element...
        if ($element.matches('.elementor-element')) {
            elementorFrontend.elementsHandler.runReadyTrigger($element);
        }

        // Init any child elements...
        $element.querySelectorAll('.elementor-element').forEach($subElement => {
            elementorFrontend.elementsHandler.runReadyTrigger($subElement);
        });
    });

}

function initializeFilterForms() {
    const $form_containers = document.querySelectorAll('.agend-query-filter-form:not([data-agend-query-filter-initialized])');

    // No forms...
    if ($form_containers.length === 0) {
        return;
    }

    // No jQuery...
    if (typeof jQuery === 'undefined') {
        return;
    }

    // Missing our AJAX URL data...
    if (!agendQueryFilter?.url) {
        return;
    }

    $form_containers.forEach($form_container => setupFormContainer($form_container));
}

document.addEventListener('DOMContentLoaded', event => {
    initializeFilterForms();
});
